import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo, breadcrumbSchema } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { PageHero, SectionHead, CtaBand, IndustryCard } from "@/components/Blocks";
import { INDUSTRY_PAGES, ALL_INDUSTRIES } from "@/data/industries";

export default function Industries() {
  const crumbs = [["Home", "/"], ["Industries", "/industries"]];
  return (
    <>
      <Seo title="Industries We Serve | Manufacturing & Industrial Solutions" description="Digital solutions for 24 industrial sectors including automotive, electronics, textiles, plastics, steel fabrication, food processing, machinery and industrial automation." path="/industries" jsonLd={[breadcrumbSchema(crumbs)]} />
      <PageHero crumbs={crumbs} eyebrow="Industries we serve" lines={["Digital Solutions", "for Every Industrial", "Sector"]} intro="We work with manufacturers, processors, fabricators, equipment builders and industrial suppliers. Explore detailed pages for the sectors below, or tell us about yours." img="grinder" imgAlt="Metal grinding with sparks in a fabrication workshop" />
      <section className="wrap py-24 lg:py-32" data-testid="industries-featured">
        <SectionHead eyebrow="Sector pages" title="Detailed industry solutions" />
        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {INDUSTRY_PAGES.map((ind, i) => <Reveal key={ind.slug} delay={(i % 3) * 0.08}><IndustryCard ind={ind} i={i} /></Reveal>)}
        </div>
      </section>
      <section className="border-t border-stone bg-white py-24 lg:py-32" data-testid="industries-all">
        <div className="wrap">
          <SectionHead eyebrow="All 24 sectors" title="Industries we support" lead="Sectors without a dedicated page are supported through the same services. Select one to start an inquiry with your industry preselected." />
          <ul className="mt-14 grid gap-px overflow-hidden rounded-md border border-stone bg-stone sm:grid-cols-2 lg:grid-cols-3">
            {ALL_INDUSTRIES.map((ind, i) => (
              <li key={ind.name} className="bg-white">
                <Link
                  to={ind.slug ? `/industries/${ind.slug}` : `/contact?industry=${encodeURIComponent(ind.name)}#inquiry`}
                  className="group flex min-h-[84px] items-center justify-between gap-4 p-6 transition-colors hover:bg-ivory"
                  data-testid={`industry-list-${i}`}
                >
                  <span className="flex items-center gap-4"><span className="font-mono text-xs text-rust-ink">{String(i + 1).padStart(2, "0")}</span><span className="font-display text-[17px] font-semibold">{ind.name}</span></span>
                  <span className="flex items-center gap-1 text-[12px] font-semibold text-graphite group-hover:text-rust-ink">{ind.slug ? "View" : "Inquire"}<ArrowUpRight className="h-4 w-4" /></span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
